import React from 'react';
import styles from './AdvtFullSize.module.css';
import { iconsSources } from '../../helpers/icons';
import { useGetParams } from '../../hooks/useGetParams';
import { formatPhoneNumber } from '../../helpers/titreHelper';
import { motion } from 'framer-motion';
import { Photos } from '../Photos/Photos';

const AdvtFullSize = React.memo(({ className, advtInfo, messages }) => {
  const {
    paddingQR,
    sizeQR,
    titleFontSize,
    phoneNumberFontSize,
    qrCode1,
    qrTitle1,
    qrCode2,
    qrTitle2,
  } = useGetParams();

  let phoneNumberFormat = formatPhoneNumber(advtInfo?.number, ' ');

  return (
    <div className={styles.wrapper}>
      {/* <div className={styles.photosBlock}>
        <Photos messages={messages} />
      </div> */}

      {advtInfo.label && (
        <motion.div
          initial={{ y: '100vh' }}
          animate={{ y: 0 }}
          transition={{ duration: 0.73 }}
          className={styles.label}
          style={{
            fontSize: `${titleFontSize}rem`,
            lineHeight: `${titleFontSize}rem`,
          }}>
          {advtInfo.label}
        </motion.div>
      )}

      {phoneNumberFormat && (
        <motion.div
          initial={{ y: '100vh' }}
          animate={{ y: 0 }}
          transition={{ duration: 0.66, delay: 0.33 }}
          className={styles.phoneNumber}
          style={{
            fontSize: `${phoneNumberFontSize}rem`,
            lineHeight: `${phoneNumberFontSize}rem`,
          }}>
          {phoneNumberFormat}
        </motion.div>
      )}

      <div className={styles.qrsContainer}>
        {qrCode1 && (
          <div className={styles.qrBlock}>
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ duration: 0.4, delay: 1 }}>
              <img
                src={qrCode1}
                alt="qrCode1"
                className={styles.qrCode}
                style={{
                  width: `${sizeQR}rem`,
                  height: `${sizeQR}rem`,
                  padding: `${paddingQR}rem`,
                }}
              />
            </motion.div>
          </div>
        )}
        {qrCode2 && (
          <div className={styles.qrBlock}>
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ duration: 0.4, delay: 1.3 }}>
              <img
                src={qrCode2}
                alt="qrCode1"
                className={styles.qrCode}
                style={{
                  width: `${sizeQR}rem`,
                  height: `${sizeQR}rem`,
                  padding: `${paddingQR}rem`,
                }}
              />
            </motion.div>
          </div>
        )}
      </div>
    </div>
  );
});

export default AdvtFullSize;
